import { StringOrNullOrUndefined } from 'src/app/shared/utils';

export class DocumentReviewed {
  document_title: string = '';
  document_status: string = '';
  constructor(data: Partial<DocumentReviewed> = {}) {
    Object.assign(this, data);
    this.document_title = StringOrNullOrUndefined(data.document_title) ?? '';
    this.document_status = StringOrNullOrUndefined(data.document_status) ?? '';
  }
}
